import { useState } from 'react';
import { useAuth } from '../lib/auth';

/**
 * Persistent "you are viewing as X" bar. Renders only when the current session
 * is an impersonation (super-admin stepped into another account). Fixed to the
 * top so it's always visible no matter which realm/page is open, and offers a
 * one-click return to the real admin account.
 */
export default function ImpersonationBanner() {
  const { user, stopImpersonating } = useAuth();
  const [exiting, setExiting] = useState(false);

  if (!user?.impersonatedBy) return null;

  async function exit() {
    setExiting(true);
    try {
      await stopImpersonating();
    } finally {
      setExiting(false);
    }
  }

  return (
    <div
      role="status"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        padding: '6px 12px',
        background: '#7c2d12',
        color: '#fff',
        fontSize: 13,
        fontWeight: 600,
        boxShadow: '0 1px 6px rgba(0,0,0,.25)',
      }}
    >
      <span aria-hidden>👁️</span>
      <span>
        Viewing as <strong>{user.name}</strong>
        {user.email ? <> · {user.email}</> : null}
        <span style={{ opacity: 0.8, fontWeight: 400 }}> — you are {user.impersonatedBy.email}</span>
      </span>
      <button
        onClick={exit}
        disabled={exiting}
        style={{
          background: '#fff',
          color: '#7c2d12',
          border: 'none',
          borderRadius: 6,
          padding: '3px 12px',
          fontSize: 12,
          fontWeight: 700,
          cursor: exiting ? 'default' : 'pointer',
          opacity: exiting ? 0.6 : 1,
        }}
      >
        {exiting ? 'Exiting…' : 'Exit'}
      </button>
    </div>
  );
}
